<template>
  <div class="job-card moreType">
    <a :href="education.linkUrl" title="상세페이지 이동">
      <div class="card-header">
        <span class="job-tag type-d">{{ education.orgName }}</span>
        <button
          class="like-button2"
          :class="{'is-active': wishStatus}"
          :aria-label="wishStatus ? '찜하기 선택됨' : '찜하기'"
          :title="wishStatus ? '찜하기 선택됨' : '찜하기'"
          :disabled="isProcessing"
          @click.prevent="handleWishClick">
          <i class="ico ico-favor"></i>
        </button>
      </div>
      <div class="card-body">
        <div class="title-line">
          {{ education.title }}
        </div>
        <div>
          <span class="label-status">{{ isFree }}</span>
          <span class="label-status">{{ isComfirm }}</span>
        </div>
        <dl class="recruitment-info bar-type">
          <dt>정원</dt>  <dd>{{ personnel }}명</dd>
          <dt>모집기간</dt> <dd>{{ registPeriod }}</dd>
          <dt>교육기간</dt> <dd class="bar">{{ coursePeriod }}</dd>
        </dl>
        <div class="button-area mypage-type1 mt-0">
          <a :href="education.linkUrl" class="btn btn-primary btn-md" v-if="this.education.status === 'WAITING'">대기신청</a>
          <a :href="education.linkUrl" class="btn btn-primary btn-md" v-if="this.education.status === 'OPEN'">수강신청</a>
          <a :href="education.linkUrl" class="btn btn-secondary btn-md is-disabled" v-if="this.education.status === 'PENDING'">신청예정</a>
          <a :href="education.linkUrl" class="btn btn-secondary btn-md is-disabled" v-if="this.education.status === 'CLOSED'">신청마감</a>
          <a :href="education.linkUrl" class="btn btn-secondary btn-md is-disabled" v-if="this.education.status === 'INCOMPLETE'">폐강</a>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import { addWish, delWish } from '../../api/wishEdu';

const Status = {
  PENDING: '수강신청예정',
  OPEN: '수강신청중',
  WAITING: '대기신청',
  CLOSED: '마감',
  INCOMPLETE: '폐강',
};

export default {
  name: 'EduCard',
  props: ['education'],
  components: {},
  data() {
    return {
      Status,
      isProcessing: false,
    };
  },
  watch: {},
  computed: {
    wishStatus() {
      return this.education.isWish === 'Y';
    },
    isFree() {
      return this.education.type.indexOf('FREE') > -1 ? '무료' : '유료';
    },
    isComfirm() {
      return this.education.type.indexOf('CONFIRM') > -1 ? '심사 후 선정' : '선착순';
    },
    personnel() {
      return this.education.personnel.toLocaleString();
    },
    registPeriod() {
      return this.formatPeriod(this.education.registStartDate, this.education.registEndDate);
    },
    coursePeriod() {
      return this.formatPeriod(this.education.courseStartDate, this.education.courseEndDate);
    },
    StatusNm() {
      return Status[this.education.status];
    },
  },
  methods: {
    convertYYYYMMDD(date) {
      if (!date) return '';
      if (date.length === 6) {
        const year = date.slice(0, 2);
        const month = date.slice(2, 4);
        const day = date.slice(4, 6);
        return `20${year}-${month}-${day}`;
      }
      return date;
    },
    formatPeriod(startDate, endDate) {
      const formatStartDate = this.convertYYYYMMDD(startDate);
      const formatEndDate = this.convertYYYYMMDD(endDate);
      if (!formatStartDate && !formatEndDate) return '';
      return `${formatStartDate} ~ ${formatEndDate}`;
    },
    async handleWishClick() {
      if (this.isProcessing) return;

      // 로그인 상태 확인
      if (!this.checkLoginStatus()) {
        // 비로그인 시 로그인 페이지로 리다이렉트
        window.location.href = '/login.do';
        return;
      }

      // 사용자 확인
      let confirmMessage;
      if (this.education.isWish === 'Y') {
        confirmMessage = '해당 강좌를 위시리스트에서 제거하시겠습니까?';
      } else {
        confirmMessage = '해당 강좌를 위시리스트에 등록하시겠습니까?';
      }

      if (!confirm(confirmMessage)) {
        return; // 사용자가 취소한 경우
      }

      this.isProcessing = true;

      try {
        let result;

        if (this.education.isWish === 'Y') {
          // 이미 찜한 상태 -> 찜 취소
          result = await delWish(this.education.id);
          if (result.success) {
            this.education.isWish = 'N';
          }
        } else {
          // 찜하지 않은 상태 -> 찜 추가
          result = await addWish(this.education.id);
          if (result.success) {
            this.education.isWish = 'Y';
          }
        }
      } finally {
        this.isProcessing = false;
      }
    },

    // 로그인 상태 확인 (전역 변수 활용)
    checkLoginStatus() {
      // window.loginMember 전역 변수 확인
      return window.loginMember === true || window.loginMember === 'true';
    },
  },
  mounted() {},
};
</script>


// WEBPACK FOOTER //
// EduCard.vue?6a16621a